// transaction.js

export class Transaction {
    constructor(app, card, taskCommit, taskFetch) {

        // public variables
        this.app = app
        this.card = card // card that created this transaction
        this.taskCommit = taskCommit
        this.taskFetch = taskFetch

        // private variables
        this._runable = true
        this._promise = null
        this._progressCallback = null
        this._errorCallback = null
        this._finishCallback = null
    }

    isRunable() {
        return this._runable
    }

    onProgress(callback) {
        this._progressCallback = callback
        return this
    }

    onError(callback) {
        this._errorCallback = callback
        return this
    }

    onFinish(callback) {
        this._finishCallback = callback
        return this
    }

    run() {
        if (this._promise) return this

        this._promise = new Promise((resolve, reject) => {
            
            this.taskCommit.onProgress(message => {
                if (this._progressCallback) this._progressCallback(message)
            })
            this.taskCommit.onError(error => {
                if (this._errorCallback) this._errorCallback(error)
                reject(error)
            })
            this.taskCommit.onFinish(assets => {

                // update card assets
                this.card.assets = assets

                this.taskFetch.onProgress((message, stage, assets) => {
                    if (this._progressCallback) this._progressCallback(message, stage, assets)
                })
                this.taskFetch.onError(error => {
                    if (this._errorCallback) this._errorCallback(error)
                    reject(error)
                })
                this.taskFetch.onFinish((assets, stage) => {
                    this._runable = false
                    if (this._finishCallback) this._finishCallback(assets, stage)
                    resolve({ assets, stage })
                })

                // run fetch task
                this.taskFetch.run(this.app, this.card)
            })

            // run commit task
            this.taskCommit.run(this.app, this.card)
        })

        return this
    }
}
